import { on } from '@ngrx/store';
import * as FraudRulesActions from '../actions/fraud-rules.actions';
import { CartState, fraudRulesAdapter } from './cart.reducer';

export const fraudRulesReducers = [
    // Fraud Rules Actions
    on(FraudRulesActions.loadFraudRules, (state: CartState) => {
        return { ...state, loading: true, error: null };
    }),

    on(FraudRulesActions.loadFraudRulesSuccess, (state: CartState, { rules }) => {
        return { ...state, fraudRules: fraudRulesAdapter.setAll(rules, state.fraudRules), loading: false };
    }),

    on(FraudRulesActions.loadFraudRulesFailure, (state: CartState, { error }) => {
        return { ...state, loading: false, error };
    }),

    on(FraudRulesActions.createFraudRule, (state: CartState) => ({
        ...state,
        error: null,
        success: false,
        loading: true,
    })),

    on(FraudRulesActions.createFraudRuleSuccess, (state: CartState) => ({ ...state, loading: false, success: true })),

    on(FraudRulesActions.createFraudRuleFailure, (state: CartState, { error }) => ({
        ...state,
        loading: false,
        error,
        success: false,
    })),

    on(FraudRulesActions.updateFraudRule, (state: CartState) => ({
        ...state,
        error: null,
        success: false,
        loading: true,
    })),

    on(FraudRulesActions.updateFraudRuleSuccess, (state: CartState) => ({ ...state, loading: false, success: true })),

    on(FraudRulesActions.updateFraudRuleFailure, (state: CartState, { error }) => ({
        ...state,
        loading: false,
        error,
        success: false,
    })),

    on(FraudRulesActions.enableFraudRule, (state: CartState) => ({
        ...state,
        error: null,
        success: false,
        loading: true,
    })),

    on(FraudRulesActions.enableFraudRuleSuccess, (state: CartState, { id }) => ({
        ...state,
        fraudRules: fraudRulesAdapter.updateOne({ id, changes: { isEnabled: true } }, state.fraudRules),
        loading: false,
        success: true,
    })),

    on(FraudRulesActions.enableFraudRuleFailure, (state: CartState, { error }) => ({
        ...state,
        loading: false,
        error,
        success: false,
    })),

    on(FraudRulesActions.disableFraudRule, (state: CartState) => ({
        ...state,
        error: null,
        success: false,
        loading: true,
    })),

    on(FraudRulesActions.disableFraudRuleSuccess, (state: CartState, { id }) => ({
        ...state,
        fraudRules: fraudRulesAdapter.updateOne({ id, changes: { isEnabled: false } }, state.fraudRules),
        loading: false,
        success: true,
    })),

    on(FraudRulesActions.disableFraudRuleFailure, (state: CartState, { error }) => ({
        ...state,
        loading: false,
        error,
        success: false,
    })),

    on(FraudRulesActions.deleteFraudRule, (state: CartState) => ({
        ...state,
        error: null,
        success: false,
        loading: true,
    })),

    on(FraudRulesActions.deleteFraudRuleSuccess, (state: CartState, { id }) => {
        return {
            ...state,
            fraudRules: fraudRulesAdapter.removeOne(id, state.fraudRules),
            loading: false,
            success: true,
        };
    }),

    on(FraudRulesActions.deleteFraudRuleFailure, (state: CartState, { error }) => ({
        ...state,
        loading: false,
        error,
        success: false,
    })),

    on(FraudRulesActions.clearFraudRulesState, (state: CartState) => ({
        ...state,
        fraudRules: fraudRulesAdapter.getInitialState(),
        loading: false,
        error: null,
    })),

    on(FraudRulesActions.getAvailableProductLines, (state: CartState) => ({ ...state, loading: true, error: null })),

    on(FraudRulesActions.getAvailableProductLinesSuccess, (state: CartState, { productLines }) => {
        return { ...state, fraudRulesAvailableProductLines: productLines, loading: false };
    }),

    on(FraudRulesActions.getAvailableProductLinesFailure, (state: CartState, { error }) => ({
        ...state,
        fraudRulesAvailableProductLines: null,
        loading: false,
        error,
    })),
];
